import ko from 'knockout';
import _ from 'underscore';
import { AdvancedOptionsView, MAX_LABEL_LENGTH } from './advanced-opt-view';
import advancedOptionsTemplate from './advanced-opt-temp.pug';

export class AdvancedOptionsSelectAllView extends AdvancedOptionsView {
  initialize({
    fields,
    schema,
    label,
    description,
    model,
    helpId,
    i18n,
  }) {
    super.initialize({
      fields, schema, label, description, model, helpId, i18n,
    });
    this.allSelected = false;
    this.includeAllOption = true;
  }

  events() {
    return {
      'click input.all': 'toggleAll',
      'click .advanced-options-form .checkbox': 'toggleAllCheckboxState',
    };
  }

  toggleAll() {
    this.allSelected = !this.allSelected;

    _.each(this.advancedOptionsFields, (field) => {
      const propertyName = field.property;

      this.form.viewModel[propertyName](this.allSelected);
    });

    this.toggleAllCheckboxState();
  }

  toggleAllCheckboxState() {
    const allCheckbox = this.$('input.all');

    if (this.areAllSelected()) {
      allCheckbox
        .prop('checked', true)
        .prop('indeterminate', false);
      this.allSelected = true;
    } else if (this.areSomeSelected()) {
      allCheckbox
        .prop('checked', false)
        .prop('indeterminate', true);
      this.allSelected = false;
    } else {
      allCheckbox
        .prop('checked', false)
        .prop('indeterminate', false);
      this.allSelected = false;
    }
  }

  render() {
    this.$el.html(advancedOptionsTemplate({
      includeAllOption: true,
      label: _.size(this.label) > MAX_LABEL_LENGTH ? `${this.label.substring(0, MAX_LABEL_LENGTH)}...` : this.label,
      i18n: this.i18n,
      helpId: this.helpId,
      fullLabel: this.label,
    }));

    ko.applyBindings(this.viewModel, this.el);

    this.$('.advanced-options-sub-items').html(this.form.render().$el);

    this.toggleAllCheckboxState();

    return this;
  }
}
